function smoothScrollTo (where, options) {
  where = where || 0
  options = options || {}

  let opt = {
    duration: options.duration || 1000,
    offset: options.offset || 0,
    callback: options.callback,
    easing: options.easing || easeInOutQuad,
    what: options.container == null || options.container === window
      ? window
      : (typeof options.container === 'string'
        ? document.querySelector(options.container)
        : options.container)
  }

  let start = opt.what === window ? window.pageYOffset : opt.what.scrollTop

  let distance = typeof where === 'string'
    ? document.querySelector(where).getBoundingClientRect().top - opt.offset
    : (typeof where === 'object'
      ? where.getBoundingClientRect().top - opt.offset
      : (opt.offset !== 0
        ? opt.offset
        : where - start))

  let duration = typeof opt.duration === 'function'
    ? opt.duration(distance)
    : opt.duration

  let timeStart = 0

  requestAnimationFrame(function (time) {
    timeStart = time
    loop(time)
  })

  function loop (time) {
    let timeElapsed = time - timeStart
    let deltaY = opt.easing(timeElapsed, start, distance, duration)

    if (opt.what === window) {
      window.scrollTo(0, deltaY)
    } else {
      opt.what.scrollTop = deltaY
    }

    if (timeElapsed < duration) {
      requestAnimationFrame(loop)
    } else {
      end()
    }
  }

  function end () {
    if (opt.what === window) {
      window.scrollTo(0, start + distance)
    } else {
      opt.what.scrollTop = start + distance
    }

    if (typeof opt.callback === 'function') {
      opt.callback()
    }
  }
}

function easeInOutQuad (t, b, c, d) {
  let result = 0

  t /= d / 2

  if (t < 1) {
    result = c / 2 * t * t + b
  } else {
    t--
    result = -c / 2 * (t * (t - 2) - 1) + b
  }

  return result
}

// we'll use this mainly for PDF's so let's default the contentType
// Uint8Array seems the fastest method: https://stackoverflow.com/a/34354313/1529778
function base64ToBlob (base64Data, contentType = 'application/pdf') {
  const raw = atob(base64Data)
  const uint8Array = new Uint8Array(new ArrayBuffer(raw.length))

  for (let i = 0; i < raw.length; i++) {
    uint8Array[i] = raw.charCodeAt(i)
  }

  return new Blob([uint8Array], {type: contentType})
}

// compare two or more objects
// the simplest & fastest way (for not so complex objects) is by comparing the JSON string
function compareObjects () {
  if (arguments.length >= 2) {
    for (let i = 0; i < arguments.length - 1; i++) {
      if (JSON.stringify(arguments[i]) !== JSON.stringify(arguments[i + 1])) {
        return false
      }
    }

    return true
  } else {
    throw new Error('You need to pass at least two objects to compare')
  }
}

// http://emailregex.com
function validateField (field, rules) {
  // field can be also event
  if (field instanceof Event || field.originalEvent instanceof Event) {
    field = field.target
  }

  const validate = field.getAttribute('data-validate')

  const regex = {
    email: /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/i,
    phone: /^(?:(?:\(?(?:00|\+)([1-4]\d\d|[1-9]\d?)\)?)?[-. \\/]?)?((?:\(?\d{1,}\)?[-. \\/]?){0,})(?:[-. \\/])?$/i,
    integer: /\d+/i
  }

  let errors = []

  // if rules not sent & data available
  if ((!rules || !rules.length) && validate) {
    rules = validate
  }

  if (rules) {
    // if string, split it by comma
    if (typeof rules === 'string') {
      rules = rules.split(/\s*,\s*/gmi)
    }

    rules.forEach(rule => {
      // if required or mandatory OR if email, phone or integer
      if (
        (/^(mandatory|required)$/i.test(rule) && ((['radio', 'checkbox'].indexOf(field.type) > -1 && !field.checked) || (['radio', 'checkbox'].indexOf(field.type) < 0 && field.value === ''))) ||
        (/^(email|phone|integer)$/i.test(rule) && field.value !== '' && !regex[rule].test(field.value))
      ) {
        errors.push(rule)
      }

      // min, max, range or between
      if (/^(min|max|range|between)/i.test(rule)) {
        // for custom checks (min, max, range, between) - only on number type
        const min = parseFloat(field.getAttribute('min') || Number.NEGATIVE_INFINITY)
        const max = parseFloat(field.getAttribute('max') || Number.POSITIVE_INFINITY)

        const value = parseFloat(field.value)

        if (
          (/^(min|range|between)/i.test(rule) && value < min) ||
          (/^(max|range|between)/i.test(rule) && value > max)
        ) {
          errors.push(rule)
        }
      }
    })
  }

  return errors
}

// This doesn't seems to work on iOS 10 Safari due to FormData bug (I suspect IE not as well)
/* function serializeForm (form) {
  if (typeof form === 'string') {
    form = document.querySelector(form)
  }

  // polyfill - IE 11 ?
  return Array.from(new FormData(form), function (e) {
    return e.map(encodeURIComponent).join('=')
  }).join('&')
} */

/*!
 * Serialize all form data into a query string
 * (c) 2018 Chris Ferdinandi, MIT License, https://gomakethings.com
 * @param  {Node}   form The form to serialize
 * @return {String}      The serialized form data
 * https://vanillajstoolkit.com/helpers/serialize/
 */
function serializeForm (form) {
  // Setup our serialized data
  var serialized = []

  // Loop through each field in the form
  for (var i = 0; i < form.elements.length; i++) {
    var field = form.elements[i]

    // Don't serialize fields without a name, submits, buttons, file and reset inputs, and disabled fields
    if (!field.name || field.disabled || field.type === 'file' || field.type === 'reset' || field.type === 'submit' || field.type === 'button') continue

    // If a multi-select, get all selections
    if (field.type === 'select-multiple') {
      for (var n = 0; n < field.options.length; n++) {
        if (!field.options[n].selected) continue
        serialized.push(encodeURIComponent(field.name) + '=' + encodeURIComponent(field.options[n].value))
      }
    } else if ((field.type !== 'checkbox' && field.type !== 'radio') || field.checked) {
      // Convert field data to a query string
      serialized.push(encodeURIComponent(field.name) + '=' + encodeURIComponent(field.value))
    }
  }

  return serialized.join('&')
}

function parseAttributeOptions (options) {
  let result = {}

  if (options && options.length) {
    const helper = options.split(/\s*;\s*/)

    helper.map(h => {
      h = h.split(/\s*:\s*/)

      result[h[0]] = h[1]
    })
  }

  return result
}

function parseCookies (cookies) {
  let result = {}

  if (!cookies) {
    cookies = document.cookie
  }

  if (cookies.length) {
    cookies.split(/;\s*/).map(c => {
      c = c.split(/\s*=\s*/)

      result[c[0]] = c[1]
    })
  }

  return result
}

function clearFormErrors (form) {
  let type

  if (typeof form === 'string') {
    form = document.querySelector(form)
  }

  const errors = {
    labels: form.querySelectorAll('[data-error]'),
    fields: form.querySelectorAll('.uk-form-danger')
  }

  for (type in errors) {
    // polyfill - IE 11 ?
    Array.from(errors[type]).forEach(el => {
      switch (type) {
        case 'labels':
          el.removeAttribute('data-error')
          break

        case 'fields':
          el.classList.remove('uk-form-danger')
          break
      }
    })
  }
}

function repairELinks () {
  const pzzls = document.querySelectorAll('.pzzl')
  let $lnk

  for (var i = 0; i < pzzls.length; i++) {
    var text = pzzls[i].innerText.split('').reverse().join('')

    if (pzzls[i].tagName.toLowerCase() === 'a') {
      $lnk = pzzls[i]
    } else {
      $lnk = pzzls[i].parentElement

      if ($lnk.tagName.toLowerCase() !== 'a') {
        if (pzzls[i].classList.contains('lnk')) {
          $lnk = wrap('a', pzzls[i])
        } else {
          $lnk = null
        }
      }
    }

    if ($lnk) {
      $lnk.setAttribute('href', ['ma', 'il', 'to:'].join('') + text)
      $lnk.setAttribute('target', '_blank')
    }

    pzzls[i].innerText = text
    pzzls[i].classList.remove('pzzl')
  }
}

function wrap (wrapper, elms) {
  // Convert `elms` to an array, if necessary.
  if (!elms.length) elms = [elms]

  // if the wrapper is sent as string (element type), create the element
  if (typeof wrapper === 'string') wrapper = document.createElement(wrapper)

  // Loops backwards to prevent having to clone the wrapper on the
  // first element (see `child` below).
  for (var i = elms.length - 1; i >= 0; i--) {
    const child = (i > 0) ? wrapper.cloneNode(true) : wrapper
    const el = elms[i]
    // Cache the current parent and sibling.
    const parent = el.parentNode
    const sibling = el.nextSibling

    // Wrap the element (is automatically removed from its current
    // parent).
    child.appendChild(el)

    // If the element had a sibling, insert the wrapper before
    // the sibling to maintain the HTML structure; otherwise, just
    // append it to the parent.
    if (sibling) {
      parent.insertBefore(child, sibling)
    } else {
      parent.appendChild(child)
    }
  }

  return wrapper
}

// returns a date & time in UTC formatted as server side MySQL Date & Time
function qdNow () {
  return new Date().toISOString().replace(/T/i, ' ').replace(/\.\d+Z/i, '')
}

// it seems that this is useless as used without locale parameter (trying to use browser's locale) it's using actually browser's language as locale which doesn't reflect systems decimal separator at all, and anyway different browsers on different OSes take into account either system regional settings or browser language anyways
function getDecimalSeparator (locale) {
  const no = 1.1

  return no
    .toLocaleString(locale)
    .substring(1, 2)
}

// inspired from rudimentary & incomplete https://stackoverflow.com/a/51840974/1529778
// https://developers.whatismybrowser.com/useragents/ (free DB & limited API)
function getBrowserInfo (ua) {
  // IMPORTANT: order of the browsers as some contains names from the others (spoof)
  var tests = [
    {
      name: 'Opera',
      regex: /(Opera|OPR)\/([^\s;$]*)/i,
      version: /Version\/([^\s;$]*)/i
    }, {
      name: 'Internet Explorer',
      regex: /(MSIE|Trident)\/([^\s;$]*)/i,
      version: /rv:([^\s;$]*)/i
    }, {
      name: 'Edge',
      regex: /(Edg(?:e|A|iOS)?)\/([^\s;]*)/i
    }, {
      name: 'Chromium',
      regex: /Chromium\/([^\s;$]*)/i
    }, {
      name: 'Chrome',
      regex: /Chrome\/([^\s;$]*)/i
    }, {
      name: 'Safari',
      regex: /Safari\/([^\s;$]*)/i,
      version: /Version\/([^\s;$]*)/i
    }, {
      // others (including Firefox): name/version at the end
      regex: /\s([^/]*)\/([^\s;]*)$/i
    }
  ]

  var browser = {
    name: null,
    major: null,
    version: null,
    isSafari: false,
    isChrome: false,
    isFirefox: false,
    isOpera: false,
    isEdge: false,
    isIE: false,
    os: null,
    hasTouch: false,
    screen: {
      width: window.screen.width,
      height: window.screen.height
    },
    window: {
      outer: {
        width: window.outerWidth,
        height: window.outerHeight
      },
      inner: {
        width: window.innerWidth,
        height: window.innerHeight
      }
    }
  }

  if (!ua) {
    ua = navigator.userAgent
  }

  if (ua) {
    tests.some(function (test) {
      // normally we should have a regex defined for each test
      if (test.regex) {
        var matches = test.regex.exec(ua)

        if (matches) {
          // if we have test name defined (missing on latest = auto detected)
          if (test.name) {
            browser.name = test.name
          }

          // some regex will return only version, others detected name as well (when multiple possibilities or no name defined)
          if (matches.length > 2) {
            var name = (browser.name ? 'ua' : '') + 'name'

            browser[name] = matches[1]
          }

          // autodetected version is the last match
          browser.version = matches[matches.length - 1]

          // do we have a custom version regex ? try it
          if (test.version) {
            matches = test.version.exec(ua)

            if (matches) {
              browser.version = matches[matches.length - 1]
            }
          }

          return true
        }
      }
    })
  }

  browser.isSafari = /safari/i.test(browser.name)
  browser.isChrome = /chrom/i.test(browser.name)
  browser.isFirefox = /firefox/i.test(browser.name)
  browser.isOpera = /opera/i.test(browser.name)
  browser.isEdge = /edge/i.test(browser.name)
  browser.isIE = /internet\sexplorer/i.test(browser.name)

  if (browser.version) {
    browser.major = parseInt(browser.version, 10)
  }

  // is touch enabled device ?
  // https://developer.mozilla.org/en-US/docs/Web/HTTP/Browser_detection_using_the_user_agent#Mobile_Device_Detection
  if ('maxTouchPoints' in navigator) {
    browser.hasTouch = navigator.maxTouchPoints > 0
  } else if ('msMaxTouchPoints' in navigator) {
    browser.hasTouch = navigator.msMaxTouchPoints > 0
  } else {
    var mQ = window.matchMedia && matchMedia('(pointer:coarse)')

    if (mQ && mQ.media === '(pointer:coarse)') {
      browser.hasTouch = !!mQ.matches
    } else if ('orientation' in window) {
      browser.hasTouch = true // deprecated, but good fallback
    } else {
      // Only as a last resort, fall back to user agent sniffing
      browser.hasTouch = (
        /\b(BlackBerry|webOS|iPhone|IEMobile)\b/i.test(ua) ||
        /\b(Android|Windows Phone|iPad|iPod)\b/i.test(ua)
      )
    }
  }

  return browser
}

/* function getInputSelection (el) {
  let start = 0
  let end = 0
  let normalizedValue
  let range
  let textInputRange
  let len
  let endRange

  if (typeof el.selectionStart === 'number' && typeof el.selectionEnd === 'number') {
    start = el.selectionStart
    end = el.selectionEnd
  } else if (document.selection) {
    range = document.selection.createRange()

    if (range && range.parentElement() === el) {
      len = el.value.length
      normalizedValue = el.value.replace(/\r\n/g, '\n')

      // Create a working TextRange that lives only in the input
      textInputRange = el.createTextRange()
      textInputRange.moveToBookmark(range.getBookmark())

      // Check if the start and end of the selection are at the very end
      // of the input, since moveStart/moveEnd doesn't return what we want
      // in those cases
      endRange = el.createTextRange()
      endRange.collapse(false)

      if (textInputRange.compareEndPoints('StartToEnd', endRange) > -1) {
        start = end = len
      } else {
        start = -textInputRange.moveStart('character', -len)
        start += normalizedValue.slice(0, start).split('\n').length - 1

        if (textInputRange.compareEndPoints('EndToEnd', endRange) > -1) {
          end = len
        } else {
          end = -textInputRange.moveEnd('character', -len)
          end += normalizedValue.slice(0, end).split('\n').length - 1
        }
      }
    }
  }

  return {
    start: start,
    end: end
  }
} */

/* function objectToQueryString (a) {
  var s = []

  let add = function (key, value) {
    // If value is a function, invoke it and return its value
    value = typeof value === 'function' ? value() : value === null ? '' : value
    s[s.length] = encodeURIComponent(key) + '=' + encodeURIComponent(value)
  }

  let buildParams = function (prefix, obj, add) {
    if (obj instanceof Array) {
      for (let i = 0, l = obj.length; i < l; i++) {
        if (/\[\]$/.test(prefix)) {
          add(prefix, obj[i])
        } else {
          buildParams(prefix + '[' + (typeof obj[i] === 'object' ? i : '') + ']', obj[i], add)
        }
      }
    } else if (typeof obj === 'object') {
      // Serialize object item.
      for (let name in obj) {
        buildParams(prefix + '[' + name + ']', obj[name], add)
      }
    } else {
      // Serialize scalar item.
      add(prefix, obj)
    }
  }

  if (a instanceof Array) {
    for (let name in a) {
      add(name, a[name])
    }
  } else {
    for (let prefix in a) {
      buildParams(prefix, a[prefix], add)
    }
  }

  return s.join('&').replace(/%20/g, '+')
} */

export { smoothScrollTo, base64ToBlob, compareObjects, validateField, clearFormErrors, serializeForm, parseAttributeOptions, parseCookies, repairELinks, qdNow, getDecimalSeparator, getBrowserInfo }



// WEBPACK FOOTER //
// ./src/utils/qdev.js